"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _fastdom = _interopRequireDefault(require("fastdom"));

var _Aria2 = _interopRequireDefault(require("./Aria"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Manage dialog (modal) elements
 *
 * @param {Object} config - Config options for AriaDialog
 * @param {HTMLElement} config.dialog - The dialog element
 * @param {HTMLElement} config.close - The dialog close button; should be the first child of the dialog
 * @param {Object} config.attributes - An Object of aria-* attributes to be added to the `target`, where the key completes an 'aria-' attribute name and the value is a valid attribute value.
 * @param {HTMLElement} config.content - The element wrapping the site content, of which the modal is NOT a child. The modal should be a child of document.body
 *
 * E.g.:
 * const modal = new AriaDialog({
 *   dialog: modalElement,
 *   close: closeElement,
 *   attributes: {
 *     label: 'Modal Title'
 *     labelledby: 'element-id'
 *     describedby: 'verbose-element-id'
 *   },
 *   content: siteWrapperElement
 * });
 */
var AriaDialog = /*#__PURE__*/function (_Aria) {
  (0, _inherits2.default)(AriaDialog, _Aria);

  var _super = _createSuper(AriaDialog);

  function AriaDialog(config) {
    var _this;

    (0, _classCallCheck2.default)(this, AriaDialog);
    _this = _super.call(this);
    _this.element = config.dialog;
    _this.closeButton = config.close;
    _this.siteContent = config.content;
    _this.attributes = config.attributes || {};
    _this.targetElement = _this.element;
    _this.overlay = document.getElementById('aria-dialog-overlay');

    if (null === _this.overlay) {
      _this.overlay = _this.constructor.createOverlayElement();
      document.body.insertBefore(_this.overlay, _this.element);
    }

    _this.isShown = false; // Bind class methods

    _this.outsideClick = _this.outsideClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.keyDownHandler = _this.keyDownHandler.bind((0, _assertThisInitialized2.default)(_this));
    _this.keydownTrapTab = _this.keydownTrapTab.bind((0, _assertThisInitialized2.default)(_this));
    _this.keydownEsc = _this.keydownEsc.bind((0, _assertThisInitialized2.default)(_this));
    _this._hide = _this._hide.bind((0, _assertThisInitialized2.default)(_this));
    _this._show = _this._show.bind((0, _assertThisInitialized2.default)(_this));
    _this.ariaHide = _this.ariaHide.bind((0, _assertThisInitialized2.default)(_this));
    _this.ariaShow = _this.ariaShow.bind((0, _assertThisInitialized2.default)(_this));
    _this.ariaToggle = _this.ariaToggle.bind((0, _assertThisInitialized2.default)(_this));

    _Aria2.default.eventPolyfill();

    _this.init();

    return _this;
  }
  /**
   * Initial element setup.
   */


  (0, _createClass2.default)(AriaDialog, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      this.element.setAttribute('aria-hidden', 'true');
      Object.keys(this.attributes).forEach(function (attr) {
        _this2.element.setAttribute("aria-".concat(attr), _this2.attributes[attr]);
      });

      _Aria2.default.dispatchAriaEvent('dialoginit', {
        expanded: this.isShown
      }, this.element);
    }
    /**
     * Close the dialog on outside click.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: "outsideClick",
    value: function outsideClick(event) {
      if (this.isShown && !this.element.contains(event.target)) {
        this.ariaHide();
      }
    }
    /**
     * Handle key presses.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: "keyDownHandler",
    value: function keyDownHandler(event) {
      if (this.isShown) {
        if (event.keyCode === this.tabKey) {
          this.keydownTrapTab(event);
        } else if (event.keyCode === this.escapeKey) {
          this.keydownEsc();
        }
      }
    }
    /**
     * Trap key tabs inside dialog.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: "keydownTrapTab",
    value: function keydownTrapTab(event) {
      this.collectInteractiveChildren();
      var focusedIndex = Array.prototype.indexOf.call(this.interactiveChildElements, document.activeElement);
      var lastItem = this.interactiveChildElements.length - 1;

      if (event.shiftKey && 0 === focusedIndex) {
        event.preventDefault();
        this.interactiveChildElements[lastItem].focus();
      } else if (!event.shiftKey && focusedIndex === lastItem) {
        event.preventDefault();
        this.interactiveChildElements[0].focus();
      }
    }
    /**
     * Close the dialog on ESC key press.
     */

  }, {
    key: "keydownEsc",
    value: function keydownEsc() {
      this.ariaHide();
    }
    /**
     * Externally-exposed hide method
     */

  }, {
    key: "ariaHide",
    value: function ariaHide() {
      _fastdom.default.mutate(this._hide);
    }
    /**
     * ARIA-hide the target element.
     *
     * @private
     */

  }, {
    key: "_hide",
    value: function _hide() {
      this.element.setAttribute('aria-hidden', 'true');
      this.siteContent.setAttribute('aria-hidden', 'false');
      this.isShown = false;
      this.closeButton.removeEventListener('click', this.ariaHide);
      document.body.removeEventListener('keydown', this.keyDownHandler);
      this.overlay.removeEventListener('click', this.outsideClick);

      _Aria2.default.dispatchAriaEvent('dialoghide', {
        expanded: this.isShown
      }, this.element);

      this.focusEl.focus();
    }
    /**
     * Externally-exposed hide method
     */

  }, {
    key: "ariaShow",
    value: function ariaShow() {
      _fastdom.default.mutate(this._show);
    }
    /**
     * ARIA-show the target element.
     *
     * @private
     */

  }, {
    key: "_show",
    value: function _show() {
      this.focusEl = document.activeElement;
      this.element.setAttribute('aria-hidden', 'false');
      this.siteContent.setAttribute('aria-hidden', 'true');
      this.isShown = true;
      this.closeButton.addEventListener('click', this.ariaHide);
      document.body.addEventListener('keydown', this.keyDownHandler);
      this.overlay.addEventListener('click', this.outsideClick);

      _Aria2.default.dispatchAriaEvent('dialogshow', {
        expanded: this.isShown
      }, this.element);

      this.collectInteractiveChildren();
      this.setFocusToFirstItem();
    }
    /**
     * Toggle ARIA attributes.
     */

  }, {
    key: "ariaToggle",
    value: function ariaToggle() {
      if (this.isShown) {
        this.ariaHide();
      } else {
        this.ariaShow();
      }
    }
  }], [{
    key: "createOverlayElement",
    value:
    /**
     * Create the dialog overlay element.
     */
    function createOverlayElement() {
      var overlay = document.createElement('div');
      overlay.id = 'aria-dialog-overlay';
      return overlay;
    }
  }]);
  return AriaDialog;
}(_Aria2.default);

exports.default = AriaDialog;